import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'luxonFormat',
})
export class LuxonFormatPipe implements PipeTransform {
  transform(date: DateTime, format: string): string {
    return date.toFormat(format);
  }
}
